import React, { useState, useEffect } from 'react';
import './Navbar.css';

// Default / Inactive Icons
import home from '../../assets/navicon/home.webp';
import work from '../../assets/navicon/work.webp';
import linkedin from '../../assets/navicon/link.webp';
import contact from '../../assets/navicon/contact.webp';
import insta from '../../assets/navicon/Insta.webp';

// Active Icons for Home and Work
import homeActive from '../../assets/navicon/homehover.webp';
import workActive from '../../assets/navicon/workhover.webp';

import { useNavigate, useLocation } from 'react-router-dom';
import { scroller } from 'react-scroll';

// ── 1. Import Sound Controller & Hover Sound Only ──
import { sounds } from '../Utils/soundEffects';
import navHoverSfx from '../../assets/sounds/mood-switch.mp3';

const NAV_ITEMS = [
  { 
    id: 'home', 
    label: 'Home', 
    icon: home, 
    activeIcon: homeActive,
    path: '/' 
  },
  { 
    id: 'work', 
    label: 'Work', 
    icon: work, 
    activeIcon: workActive,
    path: '/Work' 
  },
  { id: 'contact', label: 'Contact', icon: contact, isScroll: true },
  { id: 'insta', label: 'Instagram', icon: insta, url: 'https://www.instagram.com/pixelarchive._/' },
  { id: 'linkedin', label: 'LinkedIn', icon: linkedin, url: 'https://www.linkedin.com/in/navya-dhawde/' },
];

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [hoveredItem, setHoveredItem] = useState(null);

  // ── 2. Preload Hover Sound Buffer on Mount ──
  useEffect(() => {
    sounds.loadSound('navHover', navHoverSfx);

    const unlockAudio = () => {
      sounds.init();
      window.removeEventListener('pointerdown', unlockAudio);
      window.removeEventListener('keydown', unlockAudio);
    };

    window.addEventListener('pointerdown', unlockAudio);
    window.addEventListener('keydown', unlockAudio);

    return () => {
      window.removeEventListener('pointerdown', unlockAudio);
      window.removeEventListener('keydown', unlockAudio);
    };
  }, []);

  const openSocial = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleNavigation = (item) => {
    if (item.url) {
      openSocial(item.url);
      return;
    }

    if (item.isScroll) {
      if (location.pathname !== '/') {
        navigate('/');
        setTimeout(() => {
          scroller.scrollTo('contact', { smooth: true, duration: 400 });
        }, 120);
      } else {
        scroller.scrollTo('contact', { smooth: true, duration: 400 });
      }
      return;
    }

    if (location.pathname.toLowerCase() === item.path.toLowerCase()) {
      if (item.path.toLowerCase() === '/work') {
        window.location.reload();
      }
    } else {
      navigate(item.path);
    }
  };

  // ── 3. Sound Plays Exclusively on Hover ──
  const handleItemHover = (id) => {
    sounds.play('navHover', 0.2);
    setHoveredItem(id);
  };

  const isItemActive = (item) => {
    if (item.path) {
      return location.pathname.toLowerCase() === item.path.toLowerCase();
    }
    return false;
  };

  return (
    <nav className="liquid-navbar-wrapper" aria-label="Main Navigation">
      <div className="liquid-glass-dock">
        {NAV_ITEMS.map((item) => {
          const active = isItemActive(item);
          const hovered = hoveredItem === item.id;
          const currentIcon = active && item.activeIcon ? item.activeIcon : item.icon;

          return (
            <button
              key={item.id}
              type="button"
              className={`liquid-nav-item ${active ? 'active' : ''} ${hovered ? 'hovered' : ''}`}
              onClick={() => handleNavigation(item)}
              onMouseEnter={() => handleItemHover(item.id)}
              onMouseLeave={() => setHoveredItem(null)}
              aria-label={item.label}
            >
              {/* Sliding Oval Pill Capsule */}
              <div className="liquid-item-capsule">
                <div className="liquid-icon-wrapper">
                  <img
                    src={currentIcon}
                    alt={item.label}
                    className="liquid-nav-icon"
                  />
                </div>
                <span className="liquid-item-label">{item.label}</span>
              </div>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default Navbar;